
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { isInIframe } from '@app/helpers/iframe-helper';
import { isFullscreen, isFullscreenEnabled, toggleFullscreen } from '@commonHelpers/fullscreen-helper';
import { NgbTooltip } from '@commonNodeModules/@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@commonNodeModules/@ngx-translate/core';

@Component({
	selector: 'app-fullscreen-header',
	templateUrl: './fullscreen-header.component.html',
	styleUrls: ['./fullscreen-header.component.scss'],
	imports: [NgbTooltip, TranslatePipe]
})
export class FullscreenHeaderComponent implements OnInit {

	constructor(private cdRef: ChangeDetectorRef) { }

	ngOnInit(): void {
	}

	public async fullscreen() {
		await toggleFullscreen(document.body)
		this.cdRef.markForCheck();
	}

	public hasFullscreen() {
		return isInIframe() && isFullscreenEnabled()
	}

	public get fullscreenTextKey() {
		return `global.${isFullscreen() ? 'close' : 'fullscreen'}`
	}

	public get iconSrc() {
		const path = "/assets/orca/header/"
		if (isFullscreen()) {
			return `${path}zoom_in.svg`
		} else {
			return `${path}zoom_out.svg`
		}
	}

}
